import {
  AfterViewInit,
  Directive,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnDestroy,
  Optional,
  Output,
} from '@angular/core';
import { NgControl } from '@angular/forms';
import { atxIsMobile$ } from '@epicuro-next/ataraxia/breakpoint';
import { isNonNullish } from '@epicuro-next/utilities';
import { fromEvent, Subject } from 'rxjs';
import { filter, switchMap, takeUntil } from 'rxjs/operators';

import { MaxValueExceededEvent } from '../models/max-value-exceeded-event';

@Directive({
  selector: '[atxMax]',
  standalone: false,
})
export class MaxDirective implements AfterViewInit, OnDestroy {
  constructor(
    private host: ElementRef,
    @Optional() private ngControl?: NgControl,
  ) {
    // @HostListener('input', []) does not work on mobile
    // https://www.reddit.com/r/Angular2/comments/k4nhc4/hostlistener_keydown_or_keypress_not_working_on/
    atxIsMobile$.pipe(
      filter(Boolean),
      switchMap(() => fromEvent(host.nativeElement, 'keyup')),
      takeUntil(this.destroy$),
    );
  }
  @Input()
  public max: number;

  @Output()
  public maxExceeded = new EventEmitter<MaxValueExceededEvent>();

  private destroy$ = new Subject<void>();

  @HostListener('input', [])
  public onKeyDown() {
    this.handleKeyDown();
  }

  public ngAfterViewInit(): void {
    this.handleKeyDown();
  }

  public ngOnDestroy() {
    this.destroy$.next();
  }

  private handleKeyDown() {
    const value = this.host.nativeElement.value;

    if (isNaN(value)) {
      // not responsibility of the directive to control non numerical values
      return;
    }

    const parsedValue = parseFloat(value);
    if (parsedValue > this.max) {
      if (isNonNullish(this.ngControl) && this.ngControl.control !== null) {
        this.ngControl.control.patchValue(this.max);
      } else {
        this.host.nativeElement.value = this.max;
      }
      this.maxExceeded.emit({ value: parsedValue, max: this.max });
    }
  }
}
